import { useEffect, useState } from "react";
import { InstallPrompt } from "./InstallPrompt.jsx";
import { BottomNav } from "./BottomNav.jsx";
import { WelcomeSheet } from "./WelcomeSheet.jsx";
import { isStandalone } from "../lib/registerSW.js";

function isMobileViewport() {
  return typeof window !== "undefined" && window.matchMedia("(max-width: 900px)").matches;
}
function bottomNavEnabled() {
  try { return localStorage.getItem("pwa.bottom_nav") === "on"; } catch { return false; }
}

function UpdateBanner({ onReload, onDismiss }) {
  return (
    <div className="pwa-update-banner" role="status" aria-live="polite">
      <span className="pwa-update-text">Nieuwe versie beschikbaar</span>
      <button className="pwa-update-btn" onClick={onReload}>Herlaad</button>
      <button className="pwa-update-close" onClick={onDismiss} aria-label="Sluiten">×</button>
    </div>
  );
}

function ShellRoot() {
  const [mobile, setMobile] = useState(isMobileViewport());
  const [standalone, setStandalone] = useState(isStandalone());
  const [updateReady, setUpdateReady] = useState(false);
  const [showNav] = useState(bottomNavEnabled());

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 900px)");
    const handleMQ = () => setMobile(mq.matches);
    mq.addEventListener?.("change", handleMQ);
    const dm = window.matchMedia("(display-mode: standalone)");
    const handleDM = () => setStandalone(isStandalone());
    dm.addEventListener?.("change", handleDM);
    const handleUpdate = () => setUpdateReady(true);
    window.addEventListener("pwa:update-ready", handleUpdate);
    return () => {
      mq.removeEventListener?.("change", handleMQ);
      dm.removeEventListener?.("change", handleDM);
      window.removeEventListener("pwa:update-ready", handleUpdate);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("pwa-standalone", standalone);
    document.body.classList.toggle("pwa-mobile", mobile);
    document.body.classList.toggle("pwa-bottom-nav-on", mobile && showNav);
  }, [standalone, mobile, showNav]);

  return (
    <>
      <WelcomeSheet />
      {updateReady && (
        <UpdateBanner
          onReload={() => window.location.reload()}
          onDismiss={() => setUpdateReady(false)}
        />
      )}
      <InstallPrompt />
      {mobile && showNav && <BottomNav />}
    </>
  );
}

let mounted = false;
export function renderPWAShell() {
  if (mounted) return;
  if (typeof document === "undefined") return;
  let host = document.getElementById("pwa-shell-root");
  if (!host) {
    host = document.createElement("div");
    host.id = "pwa-shell-root";
    // CRITICAL: host element mag GEEN clicks vangen die voor de
    // onderliggende app bedoeld zijn. Individuele children krijgen
    // weer pointer-events: auto via CSS.
    host.style.cssText = "position: fixed; inset: 0; pointer-events: none; z-index: 2400;";
    document.body.appendChild(host);
  }
  import("react-dom/client").then(({ createRoot }) => {
    const root = createRoot(host);
    root.render(<ShellRoot />);
    mounted = true;
  });
}
